module.exports = __webpack_public_path__ + "img/2.52420617.jpg";